import { i18nextT } from "../../../hooks/i18n/i18n";
import type { HostingStyleMap } from "../../../utility/hosting";
import logo from "../../../designs/images/external/frankenstein/logo.png";

export const baseStyles = (): HostingStyleMap => {
  return {
    baseStyles: {
      baseColor: "#E5EBF1",
      mainColor: "#FFFFFF",
      accentColor: "#606060",
      fontPrimaryColor: "#042E69",
      fontSecondaryColor: "#042E69",
      backgroundImage: null,
    },

    commonSettings: {
      auth: {
        loginMethod: {
          twitter: true,
          facebook: false,
        },
      },
      route: {
        home: "/",
      },
      meta: {
        favicon: null,
        appleTouchIcon: null,
        title: i18nextT("hosting.templates.frankenstein1.common.meta.title"),
        description: null,
        copyright: i18nextT("hosting.templates.frankenstein1.footer.copyright"),
      },
      header: {
        logo: {
          isDisplay: true,
          path: logo,
        },
        textColor: "#042E69",
        svgColor: "#042E69",
      },
      menu: {
        home: {
          isDisplay: true,
        },
        event: {
          isDisplay: true,
          text: i18nextT(
            "hosting.templates.frankenstein1.common.section.event.name"
          ),
        },
        archive: {
          isDisplay: false,
          text: "",
        },
        account: {
          isDisplay: true,
        },
        pastEvents: {
          isDisplay: true,
          text: i18nextT(
            "hosting.templates.frankenstein1.common.section.pastEvents.name"
          ),
        },
        eventNotes: {
          isDisplay: true,
          path: null,
        },
        guide: {
          isDisplay: true,
        },
        contact: {
          isDisplay: true,
          path: null, // if use other event notes url. null is default.
        },
      },
      isDisplayBreadcrumb: true,
      isDisplayEventDate: false,
      isDisplayEventTime: false,
    },

    pageSettings: {
      topPage: {
        upcomingHeadline: {
          isDisplay: true,
          mainText: null,
          subText: null,
        },
        isDisplayTodaysEvent: false,
        isDisplayInfoArea: false,
        isDisplayDeliveryDisplayArea: false,
        isDisplayCatchCopy: false,
      },
      eventListPage: {
        /** -- 基本的にtrueで設定する -- */
        isDisplayEventDatetimeLabel: true,
        /** ------------------------- */
      },
      eventPage: {
        /** -- 基本的にtrueで設定する -- */
        isDisplayEventState: true,
        isDisplayEventTitle: true,
        isDisplayArtist: true,
        isDisplayShareButton: true,
        /** ------------------------- */
        linkInPage: {
          color: "#042E69",
          link01: {
            isDisplay: true,
            text: i18nextT(
              "hosting.templates.frankenstein1.event.linkInEvent.link01.text"
            ),
          },
          link02: {
            isDisplay: true,
            text: i18nextT(
              "hosting.templates.frankenstein1.event.linkInEvent.link02.text"
            ),
          },
          link03: {
            isDisplay: true,
            text: i18nextT(
              "hosting.templates.frankenstein1.event.linkInEvent.link03.text"
            ),
          },
          link04: {
            isDisplay: true,
            text: i18nextT(
              "hosting.templates.frankenstein1.event.linkInEvent.link04.text"
            ),
          },
          link05: {
            isDisplay: false,
            text: "",
          },
        },
        artistInfo: {
          isDisplayArtistStateLabel: false,
          headline: {
            isDisplay: true,
            text: i18nextT(
              "hosting.templates.frankenstein1.event.artistInfo.heading.text"
            ),
            subText: i18nextT(
              "hosting.templates.frankenstein1.event.artistInfo.heading.subText"
            ),
          },
        },
        purchaseButton: {
          path: null,
        },
      },
      goodsPage: {
        /** -- 基本的にtrueで設定する -- */
        isDisplayEventTitle: true,
        isDisplayArtist: true,
        isDisplayGoodsInfo: true,
        /** ------------------------- */
      },
      streamingPage: {
        isDisplaySuperChatArea: true,
      },
      accountTicketPage: {
        /** -- 基本的にtrueで設定する -- */
        isDisplayEventTitle: true,
        isDisplayArtist: true,
        isDisplayShareButton: true,
        /** ------------------------- */
      },
    },
  };
};
